import React from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Typography,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import PendingSharpIcon from "@mui/icons-material/PendingSharp";

const statusIconMap = {
  pending: { Icon: PendingSharpIcon, color: "grey", marginLeft: 1.2 },
  approved: { Icon: CheckCircleSharpIcon, color: "#4CAF50", marginLeft: 0 },
  rejected: { Icon: CancelSharpIcon, color: "#F44336", marginLeft: 0.8 },
};

function FolderDrawerGroup({
  status,
  folders,
  open,
  toggleGroup,
  selectedFolder,
  onFolderSelect,
  onMenuOpen,
  FolderListItem,
}) {
  const { Icon, color, marginLeft } = statusIconMap[status] || {};
  return (
    <Box key={status}>
      <ListItemButton
        onClick={() => toggleGroup(status)}
        sx={{
          bgcolor: "#e0e0e0",
          borderBottom: "1px solid #ccc",
          textTransform: "capitalize",
          fontWeight: "bold",
          fontSize: 14,
          px: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* ICONS OF STATUS */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography component="span" sx={{ textTransform: "capitalize" }}>
            {status}
          </Typography>
          {Icon && (
            <Icon
              sx={{
                color: color,
                fontSize: 20,
                marginLeft: marginLeft,
              }}
            />
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography component="span" sx={{ fontWeight: 400, fontSize: 18 }}>
            ({folders.length})
          </Typography>
          {open ? <ExpandLess /> : <ExpandMore />}
        </Box>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {folders.length === 0 ? (
            <ListItemText
              sx={{ pl: 4, py: 1, color: "#888" }}
              primary="No folders in this category."
            />
          ) : (
            folders.map((folder) => (
              <FolderListItem
                key={folder.folderId}
                folder={folder}
                selectedFolder={selectedFolder}
                onFolderSelect={onFolderSelect}
                onMenuOpen={onMenuOpen}
              />
            ))
          )}
        </List>
      </Collapse>
    </Box>
  );
}

export default FolderDrawerGroup;
